import { IncomeValuationProcess } from "../../types/valuation-process";

export const updateState = (
    process: IncomeValuationProcess,
    payload: {
        gross_market_rent: number | null, 
        opex: number | null,
        void_period_allowance: number | null,
        holding_period: number | null 
        terminal_capital_rate: number | null,
        annual_growth_rate: number | null,
        annual_opex_rate: number | null,
        disposal_cost_on_exit: number | null,
        discount_rate: number | null,
        value: number | null,
        file_name: string | null,
        file_path: string | null
    }
): IncomeValuationProcess => {
    return {
        ...process,
        data: {
            ...process.data,
            grossMarketrent: payload.gross_market_rent,
            opex: payload.opex,
            voidPeriodAllowance: payload.void_period_allowance,
            holdingPeriod: payload.holding_period,
            terminalCapitalRate: payload.terminal_capital_rate,
            annualGrowthRate: payload.annual_growth_rate,
            annualOpexRate: payload.annual_opex_rate,
            disposalCostOnExit: payload.disposal_cost_on_exit,
            discountRate: payload.discount_rate,
            dcfValue: payload.value,
            fileName: payload.file_name,
            filePath: payload.file_path
        }
    }
}